import React from "react";
import SubscriptionTable from "./components/SubscriptionsTable";

const SubscriptionTableContainer=()=><SubscriptionTable/>;

export default SubscriptionTableContainer;